module.exports = __webpack_public_path__ + "d234f313375c3c68978ee506ea42fe0c.png";